export default __webpack_public_path__ + "static/media/trailer_dark.2a8b1158.png";